import { ArtworkSizeSlider } from './ArtworkSizeSlider';

export default ArtworkSizeSlider;
